import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, AlertController } from 'ionic-angular';
import { Validators, FormBuilder, FormGroup } from '@angular/forms';
import {TeamappProvider} from "../../providers/teamapp";
import { Settings } from '../../settings';
import { Camera, CameraOptions } from '@ionic-native/camera';

/**
 * Generated class for the ContactPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-sickcertificate',
  templateUrl: 'sickcertificate.html',
})
export class SickcertificatePage {
  minDate:any = new Date();
  sickForm: FormGroup;

  title: string = 'Kontaktanfrage';

  sickReasonEnable: boolean = Settings.sickReason;
  sickReasonText: string = Settings.sickReasonText;
  sickReasonArray: boolean = Settings.sickReasonArray;

  sickType: any = 'au';
  policy: any;
  dateFrom: any;
  dateTill: any;
  sickReason: any = '';
  image: any = '';
  base64img: any = '';
  constructor(public navCtrl: NavController, public camera: Camera, public navParams: NavParams, private formBuilder: FormBuilder, public teamappProvider: TeamappProvider, public alertCtrl: AlertController) {

    this.minDate.setDate(this.minDate.getDate() - 14);
    let get_title = this.navParams.get("title");

    if(get_title) {
      this.title = get_title;
    }

    this.sickForm = this.formBuilder.group({
      dateFrom: ['', Validators.required],
      dateTill: ['', Validators.required],
      sickReason: [''],
      sickType: [''],
      policy: [false, Validators.required]
    });
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad SickcertificatePage');
  }

  imageCaptured() {
    const options:CameraOptions={
      quality:70,
      destinationType:this.camera.DestinationType.DATA_URL,
      sourceType: this.camera.PictureSourceType.CAMERA,
      saveToPhotoAlbum:false,
      allowEdit: false
    }
    this.camera.getPicture(options).then((ImageData=>{
      this.base64img=ImageData;
      this.image = this.base64img;
    }),error=>{
      console.log(error);
    })
  }

  submitSickform() {
    this.teamappProvider.http_request('date_from='+this.dateTill+'&reason='+this.sickReason+'&date_till='+this.dateFrom+'&image='+this.image+'&type='+this.sickType, 'sickcertificate', false, true).then(data => {
      console.log(data);
      const alert = this.alertCtrl.create({
        title: 'Erfolgreich!',
        subTitle: 'Ihre Krankmeldung wurde eingereicht und wird schnellstmöglich bearbeitet!',
        buttons: ['OK']
      });
      alert.present();
      this.navCtrl.pop();
    });
  }

}



// WEBPACK FOOTER //
// ./src/pages/sickcertificate/sickcertificate.ts